import { app } from '../../../../../app';
import { Controller } from './oidc-access-control-policy.controller';

app.component('companyManageSaaspassConnectAccessControlPolicy', {
    bindings: {
        connectApplication: '<',
        companyId: '<',
        authenticationAccessPolicyList: '<',
    },
    controller: Controller,
    templateUrl: require('./oidc-access-control-policy.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/saaspass-connect/manage/access-control-policy/oidc-access-control-policy.component.js